<div class="table-container" id="messagesNotifications">
  <table class="display" id="messagesNotificationsTable"></table>
</div>